import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Dispatch Module Service Stores
 */
export const dispatchStores: ServiceStoreConfig[] = [
  {
    name: "load",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "load-hoist-schedule",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  // Note: trailer service not in api-types yet but keeping for compatibility
  {
    name: "trailer",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "trailer-loads",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
    },
  },
  {
    name: "trailer-configurations",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
    },
  },
  // New backend service
  {
    name: "load-photos",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
];